import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks/reduxHooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAppSelector(state => state.auth);
  const location = useLocation();
  
  if (!isAuthenticated) {
    // Already redirected (guard rendered at /login) — stop, don't re-navigate.
    if (location.pathname === '/login') return null;
    // Remember the requested page (e.g. a PACS "Open in RadNeo" deep link)
    // so login can return the user to it.
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;
